export enum CONTACT_CODE {
    DEFAULT = 1,
    PARTNER = 20, // someone you play with regularly; fills the partner list when registering
    BAN = 100, // user can have no contact / message from (not possible to select by user himself).
    BLOCK_PLAYING = 101, // user is not playing against or with this contact in a qs or automated competition game
    PRIVATE_MSG = 200, // don't store this one, it is used for adding contacts who sent a private msg
}

// Codes above 99 are the server's restriction range: it loads those as "special contacts"
// and refuses to seat you with them. A friendly code has to stay below it. See DEV-NOTES.md.
export const CONTACT_CODES = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, CONTACT_CODE.PARTNER, CONTACT_CODE.BLOCK_PLAYING];
